<script lang="ts" setup>
const props = defineProps<{
  image: string
}>()
</script>

<template>
  <section
    class="container flex items-center justify-around gap-10 py-10 max-lg:flex-col"
  >
    <div class="max-h-[500px]">
      <img class="max-h-[500px]" :src="props.image" />
    </div>
    <div class="max-w-md text-right">
      <slot />
      <div class="flex justify-end gap-5">
        <slot name="ctaButton" />
        <NuxtLink href="tel:800911911">
          <button
            class="flex items-center gap-2 rounded-full bg-green-500 px-8 py-4 text-lg font-medium text-white"
          >
            <Icon name="fa6-solid:phone" />
            800 911 911
          </button>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>
